export const COLORS = {
  background: '#EFEBE0',
  errorRed: '#c53030',
  primary: '#FB4570',
  secondary: '#FB6B90',
  tertiary: '#FB8DA0',
  pinkwhite: '#EFEBE0',
  darktext: '#0e0003',
  darkBackground: '#443a3d',
  white: '#FAF9F9',
};
